var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 9921"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 25304"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FFC72C",
  "data-name": "Dot 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5,
  d: "m5.872 9.83 3.121 3.121 6.586-6.585",
  "data-name": "Path 5931"
})))));
export { SvgCheckIcon as ReactComponent };
export default "/_next/static/images/check-icon.svg";